import { format, isValid, parseISO } from "date-fns";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { PillType } from "../components/controls/Pills";

export const updateObject = (oldObject, updatedProperties) => {
  return {
    ...oldObject,
    ...updatedProperties,
  };
};

export function insertItem(array, action) {
  let newArray = array.slice();
  newArray.splice(action.index, 0, action.item);
  return newArray;
}

// needs the index and the item attributes itself
export const updateObjectInArray = (array, action) => {
  return array.map((item, index) => {
    if (index !== action.index) {
      // This isn't the item we care about - keep it as-is
      return item;
    }
    // Otherwise, this is the one we want - return an updated value
    return {
      ...item,
      ...action.item,
    };
  });
};

export const checkValidity = (value, rules) => {
  let isValid = true;
  if (!rules) {
    return true;
  }

  if (rules.required) {
    isValid = value.trim() !== "" && isValid;
  }

  if (rules.minLength) {
    isValid = value.length >= rules.minLength && isValid;
  }

  if (rules.maxLength) {
    isValid = value.length <= rules.maxLength && isValid;
  }

  if (rules.isEmail) {
    const pattern =
      /[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?/;
    isValid = pattern.test(value) && isValid;
  }

  if (rules.isNumeric) {
    const pattern = /^\d+$/;
    isValid = pattern.test(value) && isValid;
  }

  return isValid;
};

export const getLastItem = (thePath) =>
  thePath.substring(thePath.lastIndexOf("/") + 1);

export function withRouter(Component) {
  function ComponentWithRouterProp(props) {
    let location = useLocation();
    let navigate = useNavigate();
    let params = useParams();
    return <Component {...props} router={{ location, navigate, params }} />;
  }

  return ComponentWithRouterProp;
}

export const formatDate = (date) => {
  const parsedDate = parseISO(date);
  if (isValid(parsedDate)) {
    return format(parsedDate, "LLL dd, yyyy");
  }
  return date;
};

export const formatDateWithoutParsing = (date) => {
  return format(date, "LLL dd, yyyy");
};

export const formatDateStandard = (date) => {
  const parsedDate = parseISO(date);
  if (isValid(parsedDate)) {
    return format(parsedDate, "yyyy-MM-dd");
  }
  return date;
};

export const formatDateWithTime = (date) => {
  const parsedDate = parseISO(date);
  if (isValid(parsedDate)) {
    return format(parsedDate, "LLL dd, YYY h:mm a");
  }
  return date;
};

export const convertToDefEventPara = (name, value) => {
  return {
    target: {
      name,
      value,
    },
  };
};

export function classNames(...classes) {
  return classes.filter(Boolean).join(" ");
}

export function ingestBarcodeScan(scannedValue) {
  // 01 90061741049614 11 231116 3102 003801 21 6151488150
  // 0190061741049614112311163102003801216151488150
  const plu = scannedValue.substring(2, 16);
  var date = scannedValue.substring(18, 24);
  date =
    date.substring(4, 6) +
    "-" +
    date.substring(2, 4) +
    "-" +
    date.substring(0, 2);

  var weight = scannedValue.substring(28, 34);

  if (weight.substring(0, 2) != 0) {
    weight = parseInt(weight, 10) / 10000;
  } else {
    weight = parseInt(weight, 10) / 100;
  }

  const serial = scannedValue.substring(36, scannedValue.length);

  const info = { plu: plu, date: date, weight: weight, serial: serial };
  return info;
}

export function makeBeepNoise() {
  const audioString =
    "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";
  var snd = new Audio("data:audio/wav;base64," + audioString);
  snd.play();
}

export function convertToTwoDecimals(valToConvert, decimals = 2) {
  return parseFloat(valToConvert).toFixed(decimals);
}

function getJulianDatePrefix(date = new Date()) {
  const year = String(date.getFullYear()).slice(-2);
  const start = new Date(date.getFullYear(), 0, 0);
  const dayOfYear = String(
    Math.floor((date - start) / 86400000),
  ).padStart(3, "0");
  return `${year}${dayOfYear}`;
}

function randomDigits(length) {
  const max = 10 ** length;
  return String(Math.floor(Math.random() * max)).padStart(length, "0");
}

export function generateReceivingLotNumber(supplierNumber, plu) {
  const date = new Date();

  let day = date.getDate();
  let month = date.getMonth() + 1;
  let year = date.getFullYear().toString().slice(-2);
  if (month < 10) {
    month = `0${month}`;
  }

  return `${supplierNumber}${month}${day}${year}${plu}`;
}

export function generateWipLotNumber() {
  return `${getJulianDatePrefix()}${randomDigits(4)}`;
}

export const orderStatusOptions = [
  { label: "Order status", value: -1 },
  { label: "Created", value: 1, type: PillType.Warning },
  // { label: "Processing", value: 2, type: PillType.Orange },
  { label: "Picking in progress", value: 3, type: PillType.LightLime },
  // { label: "Waiting for shipment", value: 4, type: PillType.Cyan },
  { label: "Shipped", value: 5, type: PillType.DarkSky },
  { label: "Verified", value: 6, type: PillType.Success },
  // { label: "Pending payment", value: 7, type: PillType.Rose },
  // { label: "Ready for pickup", value: 8, type: PillType.DarkYellow },
  // { label: "On hold", value: 9, type: PillType.Error },
  // { label: "Refunded", value: 10, type: PillType.Error },
  { label: "Voided", value: 11, type: PillType.Error },
  // { label: "Reopened", value: 12, type: PillType.Error },
];

export const cycleCountStatusOptions = [
  { label: "Open", value: 0 },
  { label: "Closed", value: 1 },
];

export const creditReturnStatusFilterOptions = [
  { value: -1, label: "All statuses" },
  ...cycleCountStatusOptions,
];

export const employeeDepartmentsOptions = [
  { label: "All", value: 1 },
  { label: "Packaging", value: 2 },
  { label: "Production", value: 3 },
  { label: "Receiving", value: 4 },
  { label: "Shipping", value: 5 },
  { label: "Orders", value: 6 },
];

export const yesOrNoOptions = [
  { label: "No", value: 1 },
  { label: "Yes", value: 2 },
];

export const priceOptions = [
  { label: "Retail Price", value: 1 },
  { label: "Distributor Price", value: 2 },
  { label: "Wholesale Price", value: 3 },
  { label: "GMG Stores ($0)", value: 4 },
];

export const samplePackagingLabel = {
  plu: "5050.1",
  name: "TR Long Chunky 15g TR 泡参长粒15g",
  lot: "S2345D1.1",
  best_before_date: "2024-12-27",
  pieces_amount: 0,
  image_url:
    "https://greatmountainginseng.com/cdn/shop/files/logo_0054aab0-6414-4ca3-9c83-66b3087e3059.png?v=1635533421",
  weight_kg: "22.91 kg NET WT",
  weight_lb: "50.51 lb NET WT",
  barcode_html:
    "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",
  barcode_str: "0100000000012304112410093102000400214018321115",
};

export const userTypeOptions = [
  { value: 1, label: "Employee" }, // READ-ONLY
  { value: 2, label: "Supervisor" },
  { value: 3, label: "Management" },
];

// Utility functions for permission checking
// Read-only if: user_type === 1 (Employee) OR id === 11 OR id === 12
export const isReadOnlyUser = () => {
  // Handle both string and number comparisons for userType and userId
  const userTypeNum = parseInt(localStorage.getItem("user_type"));

  return userTypeNum === 1;
};

export const isManagementUser = () => {
  // Handle both string and number comparisons for userType and userId
  const userTypeNum = parseInt(localStorage.getItem("user_type"));

  return userTypeNum === 3;
};

export const hasWritePermission = (userType, userId) =>
  isReadOnlyUser(userType, userId);

// Alternative function that accepts Redux state object
export const isReadOnlyUserFromState = (authState) => {
  return isReadOnlyUser(authState.user_type, authState.id);
};

export const standardWeightOptions = [
  { value: 1, label: "kg" },
  { value: 2, label: "lbs" },
];

export const weightUnitOfMeasureOptions = [
  { value: 1, label: "weight" },
  { value: 2, label: "pieces" },
];

export const stockUnitOfMeasureOptions = [
  { value: 1, label: "kg" },
  { value: 2, label: "lbs" },
  { value: 3, label: "pieces" },
];

export const productUnitOfMeasureOptions = [
  { value: 1, label: "weight" },
  { value: 2, label: "pieces" },
];

export function convertToCurrencyFormat(amount, fractionDigits = 4) {
  return new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
    minimumFractionDigits: fractionDigits,
    maximumFractionDigits: fractionDigits,
  }).format(amount);
}

export function getSourceItemUnitLabel(sellingUnitOfMeasure) {
  const unitType = parseInt(sellingUnitOfMeasure, 10);
  switch (unitType) {
    case 1:
      return "kg";
    case 2:
      return "lbs";
    case 3:
      return "pieces";
    default:
      return "";
  }
}

export function getSourceItemParentQuantity(sourceItem) {
  const unitType = parseInt(sourceItem.selling_unit_of_measure, 10);
  switch (unitType) {
    case 1:
      return parseFloat(sourceItem.net_weight_kg || 0);
    case 2:
      return parseFloat(sourceItem.net_weight_lbs || 0);
    case 3:
      return parseFloat(sourceItem.piece_count || 0);
    default:
      return parseFloat(sourceItem.piece_count || 0);
  }
}

export function sumSourceItemSplitQuantities(priceSplits, excludeSplitId = null) {
  return (priceSplits || []).reduce((sum, split) => {
    if (excludeSplitId !== null && split.id === excludeSplitId) {
      return sum;
    }
    return sum + parseFloat(split.quantity || 0);
  }, 0);
}

export function getSourceItemRemainder(sourceItem) {
  const quantity =
    sourceItem.remainder_quantity != null
      ? parseFloat(sourceItem.remainder_quantity)
      : getSourceItemParentQuantity(sourceItem) -
        sumSourceItemSplitQuantities(sourceItem.price_splits);

  return {
    quantity,
    unitPrice: 0,
    subtotalPrice: 0,
  };
}

export function mapSourceItemTaxes(sourceItem) {
  if (sourceItem?.taxes?.length) {
    return sourceItem.taxes;
  }

  return (sourceItem?.tax_rates ?? []).map((taxRate) => ({
    value: taxRate.id,
    label: taxRate.name,
    rate: parseFloat(taxRate.pivot?.rate ?? taxRate.rate ?? 0),
  }));
}

export function enrichTaxesWithDropdownRates(taxes, options) {
  return (taxes ?? []).map((tax) => {
    const match = (options ?? []).find((opt) => opt.value === tax.value);
    if (match) {
      return {
        value: match.value,
        label: match.label,
        rate: parseFloat(match.rate ?? 0),
      };
    }

    return {
      ...tax,
      rate: parseFloat(tax.rate ?? 0),
    };
  });
}

export function sumSourceItemTaxRates(taxes) {
  return (taxes ?? []).reduce(
    (sum, tax) => sum + parseFloat(tax.rate ?? 0),
    0,
  );
}

export function getSourceItemRemainderTaxAmount(sourceItem) {
  const splits = sourceItem.price_splits ?? [];
  if (splits.length === 0) {
    return parseFloat(sourceItem.tax_amount ?? 0);
  }

  const splitTaxTotal = splits.reduce(
    (sum, split) => sum + parseFloat(split.tax_amount ?? 0),
    0,
  );

  return Math.max(
    0,
    parseFloat(sourceItem.tax_amount ?? 0) - splitTaxTotal,
  );
}

export function isSourceItemReturned(sourceItem) {
  return (
    sourceItem.is_returned === 1 || parseInt(sourceItem.credit_return_id, 10) > 0
  );
}

export const receivingStatusOptions = [
  { value: 0, label: "Open", type: PillType.DarkYellow },
  { value: 1, label: "Closed", type: PillType.Success },
  { value: 2, label: "Pending Receiving", type: PillType.Success },
];

export const receivingStatusFilterOptions = [
  { value: -1, label: "All statuses" },
  ...receivingStatusOptions,
];

export const wipStatusOptions = [
  { value: 0, label: "Open", type: PillType.DarkYellow },
  { value: 1, label: "Closed", type: PillType.Success },
];

export const wipsScreenStatusOptions = [
  { value: 0, label: "Open", type: PillType.DarkYellow },
  { value: 1, label: "Closed", type: PillType.Success },
  { value: 2, label: "Open & Closed", type: PillType.Success },
];

export const weighingModeOptions = [
  { value: 0, label: "Standard" },
  { value: 1, label: "Catch weight" },
];

export const labSampleOptions = [
  { value: 0, label: "Created", type: PillType.Gray },
  { value: 1, label: "Submitted", type: PillType.DarkYellow },
  { value: 2, label: "Completed", type: PillType.Success },
];

export function generateUniqueNumber() {
  const now = new Date();
  const month = String(now.getMonth() + 1).padStart(2, "0"); // getMonth() returns 0-11, so add 1
  const day = String(now.getDate()).padStart(2, "0");
  const hours = String(now.getHours()).padStart(2, "0");
  const minutes = String(now.getMinutes()).padStart(2, "0");
  const seconds = String(now.getSeconds()).padStart(2, "0");

  const uniqueNumber = `${month}${day}${hours}${minutes}${seconds}`;
  return uniqueNumber.slice(-10); // Ensure it's 10 digits
}

export const isPositiveInteger = (val) => {
  let str = String(val);

  str = str.trim();

  if (!str) {
    return false;
  }

  str = str.replace(/^0+/, "") || "0";
  let n = Math.floor(Number(str));

  return n !== Infinity && String(n) === str && n >= 0;
};

export function convertStatus(status) {
  const statusOption = orderStatusOptions.filter((el) => el.value === status);

  return statusOption.length === 1
    ? { text: statusOption[0].label, type: statusOption[0].type }
    : { text: orderStatusOptions[0].label, type: orderStatusOptions[0].type };
}

export function convertReceivingStatus(status) {
  const statusOption = receivingStatusOptions.filter(
    (el) => el.value === status,
  );

  return statusOption.length === 1
    ? { text: statusOption[0].label, type: statusOption[0].type }
    : {
        text: receivingStatusOptions[0].label,
        type: receivingStatusOptions[0].type,
      };
}

export function convertLabSampleStatus(status) {
  const statusOption = labSampleOptions.filter((el) => el.value === status);

  return statusOption.length === 1
    ? { text: statusOption[0].label, type: statusOption[0].type }
    : { text: labSampleOptions[0].label, type: labSampleOptions[0].type };
}

export function getSerialFromBarcode(barcode) {
  return barcode.slice(-10);
}
